<template>
    <b-form class="mt-3 w-sm-75">
        <UserProfileInputs
            v-bind.sync="user"
            @blur:email="checkIfEmailIsAvailable"
        />
        <UserPasswordInput v-bind.sync="user" />
        <UserPersonaSelect :role.sync="roleToAdd" />
        <b-form-row>
            <!-- TODO: Split dropdown button might be a better option here -->
            <b-col cols="4"
                   sm="4"
                   md="3"
                   offset-sm="2"
                   offset-md="2"
            >
                <v-button
                    prevent-default
                    :disabled="buttonDisabled"
                    @click="createAndClear"
                >
                    <fa-icon :icon="['fas', 'user-check']" />Create
                </v-button>
            </b-col>
            <b-col cols="6"
                   sm="5"
                   md="4"
                   lg="3"
                   offset-sm="1"
            >
                <v-button
                    prevent-default
                    :disabled="buttonDisabled"
                    @click="createAndNavigate({name: 'admin.users.Personae'})"
                >
                    <fa-icon :icon="['fas', 'user-edit']" />Create and Edit
                </v-button>
            </b-col>
        </b-form-row>
        <b-form-text id="createUserFormHelpText" class="form-text text-muted text-center">
            Please fill out or select each available option to enable the buttons.
        </b-form-text>
    </b-form>
</template>

<script>
import { alertManager } from '~/plugins/alertManager';
import UserProfileInputs from './UserProfileInputs';
import UserPasswordInput from './UserPasswordInput';
import UserPersonaSelect from './UserPersonaSelect';

const emptyUser = {
    email: null,
    fname: null,
    lname: null,
    phone: null,
    password: null,
    roles: [],
};

export default {
    name: 'UserCreate',

    components: {
        UserProfileInputs,
        UserPasswordInput,
        UserPersonaSelect,
    },

    data() {
        return {
            user: {
                ...emptyUser,
            },
            roleToAdd: null
        };
    },

    computed: {
        buttonDisabled() {
            let invalidConditions = [
                ['', null].includes(this.user.email),
                ['', null].includes(this.user.fname),
                ['', null].includes(this.user.lname),
                ['', null].includes(this.user.password),
                this.user.roles.length === 0,
                !this.user.roles.reduce((allValid, role) => {
                    const isApplicantRole = ['AP', 'RO'].includes(role.roleId);
                    if (isApplicantRole) {
                        return allValid && role.applicantId !== null;
                    }

                    return allValid && role.applicantId === null;
                }, true),
            ];

            return invalidConditions.some((condition) => condition);
        },
    },

    watch: {
        roleToAdd() {
            this.user.roles = this.user.roles || [];
            this.$set(this.user.roles, 0, this.roleToAdd);
        },
    },

    methods: {
        async createUser() {
            try {
                const createdUser = await this.$store.dispatch('auth/createUser', this.user);
                alertManager.showSuccess({
                    message: 'Created user successfully.',
                });
                return createdUser.user_id;
            } catch (error) {
                alertManager.showErr(error);
            }
        },

        async createAndClear() {
            await this.createUser();
            this.user = { ...emptyUser };
            this.roleToAdd = null;
        },

        async createAndNavigate(route) {
            const userId = await this.createUser();
            route.params = { userId };
            this.$router.push(route);
        },

        async checkIfEmailIsAvailable(email) {
            if (this.user.email !== null && this.user.email !== '') {
                this.userList = await this.$store.dispatch('auth/searchUsers', {
                    criteria: this.user.email,
                });

                if (this.userList && this.userList.length > 0) {
                    alertManager.showErr(
                        new Error(
                            'The email address ' +
                                this.user.email +
                                ' is already in use. Please search for this user to edit or use a different email'
                        )
                    );
                    this.user.email = null;
                }
            }
        },
    },
};
</script>
